var UIAccordion = (function ($) {

    UIAccordion = function () {
        var that = this;

        // DOM

        // CONST
        that.class = {
            is_active: 'is-active',
            is_one_active: 'is-one-active'
        };
        that.data_keys = {
            is_move: 'is-move'
        };

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    UIAccordion.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UIAccordion.prototype.initEventHandlers = function () {
        var that = this;
        
        $.sa.$document.on('click', '.js-accordion-button', function (e) {
            var $accordion_button = $(this);

            e.preventDefault();
            e.stopPropagation();

            if ($accordion_button.data(that.data_keys.is_move)) {
               return; 
            }

            var $accordion_item = $accordion_button.parents('.js-accordion-item'),
                $accordion_content = $accordion_item.find('.js-accordion-content'),
                $accordion = $accordion_item.parents('.js-accordion'),
                is_one_active = $accordion.hasClass(that.class.is_one_active),
                is_active = $accordion_item.hasClass(that.class.is_active),
                auto_scroll = $accordion.hasClass('js-auto-scroll');

            if (is_one_active) {
                $accordion.find('.js-accordion-content').slideUp({
                    start: function(){
                        $accordion_button.data(that.data_keys.is_move, true);
                    },
                    done: function() {
                        $(this).parents('.js-accordion-item').removeClass(that.class.is_active);
                        $accordion_button.removeData(that.data_keys.is_move);
                    }
                });
            }
            
            if (!is_one_active || !is_active) {
                $accordion_content.slideToggle({
                    start: function(){
                        $accordion_button.data(that.data_keys.is_move, true);
                    },
                    done: function() {
                        $accordion_item.toggleClass(that.class.is_active);
                        $accordion_button.removeData(that.data_keys.is_move);
                    },
                    complete: function () {
                        if ($accordion_item.hasClass(that.class.is_active) && auto_scroll) {
                            const animation_time = 100;
                            //timeout нужен, чтобы пропустить рендер анимации
                            setTimeout(() => {
                                requestAnimationFrame(function () {
                                    $accordion_item[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                                });
                            }, animation_time);
                        }
                    }
                });
            }
        });

        $.sa.$window.on('hashchange load', function(e){
            var hash = window.location.hash,
                $wrapper = $('.js-accordion');

            if (!!hash && $wrapper.length) {
                var $accordion_item = $wrapper.find('[data-accordion-item-for=' + hash.substring(1) + ']').first(),
                    $accordion_button = $accordion_item.find('.js-accordion-button');

                if ($accordion_item.length) {
                    !$accordion_item.hasClass(that.class.is_active) && $accordion_button.trigger('click');
                    $.sa.scrollToNode($accordion_button, 200, null);
                }
            }
        });
        
    };

    return UIAccordion;
})($);

/**
 * Accordion Builder Plugin
 * 
 * Options:
 *      wrapper_tag = 'div', 'span', etc... (default: div)
 *      wrapper_class = 'large', 'small', 'left', 'clear', 'is-one-active' (default: none)
 *      item_tag = 'div'
 *      title_tag = 'div'
 *      title_button_tag = 'button'
 *      title_icon = icon class (default: fab fa-sa-chevron-down)
 *      accordion_data = ['title', 'content']
 **/
(function ($) {

    var UIAccordionBuilder = (function ($) {

        UIAccordionBuilder = function (options) {
            var that = this;
            
            that.options = options;
            
            that.data = options['data'];
            that.wrapper_tag = (options['wrapper_tag'] || 'div');
            that.wrapper_class = (options['wrapper_class'] || null);
            that.item_tag = (options['item_tag'] || 'div');
            that.title_tag = (options['title_tag'] || 'div');
            that.title_button_tag = (options['title_button_tag'] || 'button');
            that.title_icon = (options['title_icon'] || 'fab fa-sa-chevron-down');
            
            return that.build();
        };

        UIAccordionBuilder.prototype.build = function () {
            var that = this,
                data = that.data,
                $accordion = $('<' + that.wrapper_tag + ' class="accordion js-accordion" />');
            
            if (that.wrapper_class) {
                $accordion.addClass(that.wrapper_class);
            }
            $.each(data, function(i, item) {
                var $item = $('<' + that.item_tag + ' class="accordion-item js-accordion-item" />'),
                    $button = $('<'+ that.title_button_tag +' class="accordion-button js-accordion-button" />'),
                    $title = $('<' + that.title_tag +' class="accordion-title" />'),
                    $title_text = $('<span class="accordion-text"><span></span></span>'),
                    $title_description = null,
                    $button_icon = $('<span class="accordion-icon"><i class="' + that.title_icon + '"></i></span>'),
                    $content = $('<div class="accordion-content js-accordion-content" />');

                $content.html(item['content']);
                
                if (item['link']) {
                    $button = $('<a class="accordion-button" href="' + item['link'] + '" />');
                    $content = null;
                    
                    if (item['link_target']) {
                        $button.attr('target', item['link_target']);
                    }
                    if (item['link_icon_class']) {
                        $button_icon = $('<span class="accordion-icon"><i class="' + item['link_icon_class'] + '"></i></span>');
                    }
                }
                
                if (item['description']) {
                    $title_description = $('<span class="accordion-description">' + item['description'] + '</span>')
                }
                
                $title_text.find('span').text(item['title']);
                $title_text.append($title_description);
                $title.append($title_text);
                $button.append($title);
                $button.append($button_icon);
                $item.append($button);
                $item.append($content);
                
                $accordion.append($item);
            });

            return $accordion;
        };
        
        return UIAccordionBuilder;
    })($);
    
    $.uiAccordionBuilder = function (plugin_options) {
        plugin_options = (typeof plugin_options === 'object' ? plugin_options : {});
        var options = $.extend(true, {}, plugin_options);
        return new UIAccordionBuilder(options);
    };
    
})(jQuery);